module.exports = __webpack_public_path__ + "static/media/beats.18d387bf.mp3";